import {Injectable, Type} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../../core/shared/service/crud/mvs-crud.service';
import {MvsCrudModeEnum} from '../../../../../core/shared/service/crud/mvs-crud-mode.enum';

@Injectable({
    providedIn: 'root'
})
export class SpBoardTemplateLaneService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/sp/boardTemplateLanes');
    }

    getObjectComponent(mode?: MvsCrudModeEnum): Type<any> {
        return null;
    }
}
